// Core
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Route, Switch, Redirect, useRouteMatch, useHistory, useLocation, NavLink, Link } from 'react-router-dom';
import {
  Button,
  Box,
  Flex,
  Grid,
  Text,
  Image,
  useColorModeValue,
  useColorMode
} from '@chakra-ui/react';

// Accets
import { getInitials, formatDateWithSuffix, validateLoadMore, parseNotifyDate } from 'services/Utils';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import { ReactComponent as PendingIcon } from 'assets/svg/wallet/pending.svg';
import { ReactComponent as LockedIcon } from 'assets/svg/wallet/locked.svg';
import crystal from 'assets/img/wallet/crystal.png';
import cube from 'assets/img/wallet/cube.png';
import tickets from 'assets/img/wallet/tickets.png';

// Components
import Card from 'components/Card/Card';

const Balance = ({ userData }) => {
	const bg = useColorModeValue('white', '#0A1027');
	const border = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');
  	const boxShadow = useColorModeValue('unset', '0px 1px 3px 0px rgba(0, 0, 0, 0.10),0px 1px 2px 0px rgba(0, 0, 0, 0.06)');
  	const textColor = useColorModeValue('#262D47 !important', 'rgb(159, 171, 203) !important');
  	const textShadow = useColorModeValue('unset', '1px 1px black');
  	const dividerDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 42.74%, #FFF 50.39%, #38A9E1 57.37%, rgba(56, 169, 225, 0.00) 100%)';
  	const dividerWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 3.65%, #38A9E1 8.19%, #38A9E1 13.55%, rgba(56, 169, 225, 0.00) 100%)';
  	const divider = useColorModeValue(dividerWhite, dividerDark);

  	const { colorMode } = useColorMode();
  	const isDark = colorMode === 'dark';

	const { path } = useRouteMatch();

	const balance = userData?.balances?.affiliatePartnersCashbackBalance;

	const titleStyle = {
		color: '#9FABCB',
		fontSize: '13px',
		fontStyle: 'normal',
		fontWeight: '500',
		lineHeight: '18px',
		letterSpacing: '-0.4px',
		textTransform: 'uppercase',
		marginBottom: '8px',
		zIndex: '2'
	};

	const sumStyle = {
		fontStyle: 'normal',
		fontWeight: '900',
		lineHeight: 'normal',
		letterSpacing: '-0.4px',
		zIndex: '2'
	};

	return (
		<Card padding={{base: '16px', md: '32px 24px'}} bg={bg} border={border} boxShadow={boxShadow} mt="16px">
			<Card padding="12px" bg={bg} border={border} boxShadow={boxShadow} overflow="hidden">
				<Text style={titleStyle} textShadow={textShadow} color={textColor}>Available</Text>
				<Text variant="title-lg" style={sumStyle} textShadow={textShadow} fontSize={{base: '24px', md: '32px'}}>${balance?.available / 100 || 0}</Text>

				{ isDark ? <Lines className="abstract-lines" style={{ zIndex: '1'}} />
				: <LinesWhite className="abstract-lines" style={{ zIndex: '1', opacity: 0.3 }} /> }
				{ isDark && <Box position="absolute" 
					bg="#099BFF" 
					filter="blur(40px)" 
					w="50%" h="20px" position="absolute" 
					bottom="-20px" left="0" /> }

				<Image zIndex="1" src={tickets} alt="Tickets" position="absolute" top="0" right="0px" h="100%" />

				<Box 
					w="100%"
					h="2px"
					bg={divider}
					position="absolute"
					bottom="0" />
			</Card>

			<Flex mt="16px" gap="16px">
				<Card padding="12px" bg={bg} border={border} boxShadow={boxShadow} overflow="hidden">
					<Flex justifyContent="space-between" w="100%">
						<Text style={titleStyle} color={textColor}>Pending</Text>
						<PendingIcon />
					</Flex>
					<Text variant="title-lg" style={sumStyle} fontSize={{base: '20px', md: '24px'}}>${balance?.pending / 100 || 0}</Text>

					{ isDark ? <Lines className="abstract-lines" style={{ zIndex: '1'}} />
						: <LinesWhite className="abstract-lines" style={{ zIndex: '1', opacity: 0.3 }} /> }

					{ isDark && <Box position="absolute" 
						bg="#099BFF" 
						filter="blur(40px)" 
						w="50%" h="20px" position="absolute" 
						bottom="-20px" left="0" /> }
				</Card>

				<Card padding="12px" bg={bg} border={border} boxShadow={boxShadow} overflow="hidden">
					<Flex justifyContent="space-between" w="100%">
						<Text style={titleStyle} color={textColor}>locked</Text>
						<LockedIcon />
					</Flex>
					<Text variant="title-lg" style={sumStyle} fontSize={{base: '20px', md: '24px'}}>${balance?.locked / 100 || 0}</Text>

					{ isDark ? <Lines className="abstract-lines" style={{ zIndex: '1'}} />
						: <LinesWhite className="abstract-lines" style={{ zIndex: '1', opacity: 0.3 }} /> }
					{ isDark && <Box position="absolute" 
						bg="#099BFF" 
						filter="blur(40px)" 
						w="50%" h="20px" position="absolute" 
						bottom="-20px" left="0" /> }
				</Card>
			</Flex>

			{/*<NavLink to="/account/wallet/withdraw">
				<Button variant="button-lg-g" mt="16px">Withdraw</Button>
			</NavLink>*/}
			<Button variant="button-lg-g" disabled={true} mt="16px">Coming soon</Button>

		</Card>
	);
};

export default Balance;